var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-block",on:{"click":function($event){_vm.isShowBlock = !_vm.isShowBlock}}},[_c('h3',{staticClass:"question-block__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"question-block__body"},[_c('transition',{attrs:{"name":"slide"}},[(_vm.isShowBlock)?_vm._t("default"):_vm._e()],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }